// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const NavigationWithIconsTheme: ThemeFile = {
  aw: {
    classes: {
      /** Insert Theme classes here **/
    },
  },
  rba: {
    classes: {
      wrapper:
        'col-span-12 w-full px-s py-xxs [&_a]:!no-underline [&_a:hover]:!no-underline [&_a:focus]:!no-underline ' +
        '[&_a:focus-visible]:outline-none [&_.slick-list]:h-full [&_a]:select-none [&_a]:[WebkitTapHighlightColor:transparent] ' +
        '[&_.slick-track]:flex [&_.slick-track]:items-center ' +
        '[&_.slick-slide>div]:h-full [&_.slick-slide>div]:flex [&_.slick-slide>div]:items-center ' +
        '[&_.slick-list]:pr-s md:[&_.slick-list]:pr-m ml:[&_.slick-list]:pr-0 ' +
        '[&_.slick-arrow]:top-[calc(50%-6px)] [&_.slick-arrow]:-translate-y-1/2',
      slide: 'h-full flex items-center px-xxs ml:px-xs',
      firstNavItem:
        'w-full flex-col self-stretch text-center md:flex-row min-h-[3.5rem] md:items-center md:justify-center md:text-left',
      firstNavItemLabel:
        'whitespace-normal break-words text-center md:order-1 md:text-left !leading-[1.1] body-copy font-serif text-body font-bold',
      firstNavItemIcon: 'order-[-1] mb-xxs md:order-2 md:mb-0 md:ml-xxs ml:ml-xxs',
      navItem:
        'group relative flex w-full flex-col items-center justify-center min-h-[3.5rem] text-center cursor-pointer select-none touch-pan-x ' +
        'focus:border-none focus-visible:border-none lg:hover:border-b-4 lg:hover:border-primary',
      activeItem: 'border-b-4 border-primary',
      logoNavItem: 'justify-center min-h-[3.5rem] flex h-full flex-col w-full items-center',
      logoNavItemActive: 'ml:border-b-4 ml:border-primary',
      logoImage:
        'w-[5.625rem] md:w-20 ml:w-[8.75rem] object-contain pointer-events-none select-none',
      iconImage: 'h-5 w-5 object-contain pointer-events-none select-none',
      label:
        'text-center whitespace-normal break-words line-clamp-2 body-copy font-serif ml:text-body font-bold pointer-events-none select-none',
    },
  },
};
